import axiosInstance from '../../../helpers/backend_helper';

const getAllUsers = async () => {
  try {
    const response = await axiosInstance.get('api/v1/admins/getAllUsers');
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export default getAllUsers;
